import {useSearchBox} from "react-instantsearch";
import {useConfigContext} from "@/ConfigProvider";

export function SearchHeader() {
    const {tc,algoliaConfig: {isSearch}} = useConfigContext();
    const {query} = useSearchBox();
    return (
        <>
            {
                isSearch &&
                <h1>{tc.search_prefix}{" "}{query}</h1>
            }
        </>
    )
}